import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'p8-page-block',
  templateUrl: './page-block.component.html',
  styleUrls: ['./page-block.component.scss']
})
export class PageBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
